import { Group, Button, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';

import { TWhitelistCreateParams } from '../store/types';

type FormData = TWhitelistCreateParams;

type Props = {
  onSubmit: (params: TWhitelistCreateParams) => void;
  onClose: () => void;
};

export const CreateWhitelistForm = (props: Props) => {
  const { onSubmit, onClose } = props;

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {
      ip: '',
      note: '',
    },
    validate: {
      ip: (value) => value.length < 1 ? 'Введите IP адрес' : null,
      note: (value) => value.length < 1 ? 'Введите описание' : null,
    },
  });

  const handleSubmit = (values: FormData) => {
    const params: TWhitelistCreateParams = {
      ip: values.ip,
      note: values.note,
    };
    onSubmit(params);
    onClose();
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <TextInput
        label="IP"
        withAsterisk
        key={form.key('ip')}
        {...form.getInputProps('ip')}
      />
      <TextInput
        label="Описание"
        withAsterisk
        key={form.key('note')}
        {...form.getInputProps('note')}
      />
      <Group justify="flex-end" mt="30">
        <Button variant="outline" onClick={() => onClose()}>
          Отменить
        </Button>
        <Button type="submit">
          Добавить
        </Button>
      </Group>
    </form>
  );
};
